import {getJson} from '../api/Http';
import {APP_DETAILS} from './Types';

const params = () => {
  const url = window.location.href;
  return url.slice(url.indexOf('?'));
};

export const getQRCode = () => dispatch =>
  getJson(`/qr${params()}`)
    .then(json => 
      dispatch({
        type: APP_DETAILS,
        payload: {
          qrCode: json.qrCode,
          ios: json.ios,
          android: json.android,
          title: json.title,
          description: json.description,
          logo: json.logo,
        },
      }));
